@use "ui/styles/colorsOld";

.wrapper {
  width: 100%;
  height: 8px;
  border-radius: 999pc;
  background-color: colorsOld.$stoneLightX2;
  :global {
    .bar {
      position: absolute;
      border-radius: 999pc;
      background-color: colorsOld.$sapphireLight;
      height: 8px;
      z-index: 1;
      transition: all 1s;
    }
  }
}
